import LocalizedStrings from 'react-localization';

export let strings = new LocalizedStrings({
    en: {
        navigationLogin: {
            textParagraph: 'Already have an account?',
            textButton: 'Login',
            href: '/login'
        },
        navigationVerify: {
            textButton: 'Back to homepage',
            href: '/'
        },
        emailVerify: {
            heading: 'Email verification',
            textParagraph: 'To complete the registration process look for an email in your inbox that provides further instructions. If you cannot find the email, please check your spam email.'
        },
        signUpTestimonial: {
            textBlockquote: 'One of the best tools I have ever used. It is easy to use and very productive, every restaurant should have a chatbot in Facebook!',
            textHeadingThree: 'Ezequiel Treviño',
            textParagraph: 'Owner of El Rey Tiburón'
        }
    },
    es: {
        navigationLogin: {
            textParagraph: 'Ya estas registrado?',
            textButton: 'Iniciar sesión',
            href: '/login'
        },
        navigationVerify: {
            textButton: 'Regresar',
            href: '/'
        },
        emailVerify: {
            heading: 'Verificar correo',
            textParagraph: 'Para completar el proceso de registro, porfavor revisa tu correo electrónico y sigue las intrucciones para activar tu cuenta. Si no puedes encontrar el correo, revisa en la sección de spam.'
        },
        signUpTestimonial: {
            textBlockquote: 'Una de las mejores herramientas que he usado. Es fácil de usar y muy productiva, todos los restaurantes deberían tener un chatbot en Facebook!',
            textHeadingThree: 'Ezequiel Treviño',
            textParagraph: 'Dueño de El Rey Tiburón'
        }
    }
});


// WEBPACK FOOTER //
// ./src/redux/components/pages/SignUp/SignUpContent.js